import React, { useEffect } from 'react';
import type { ErrorBlock } from '../../store/chatStore';
import { ChatMarkdown } from '@plerionhq/design-system/unstable';
import { useQueryClient } from '@tanstack/react-query';

import { useTranslation } from 'react-i18next';

interface ErrorContentProps {
  content: ErrorBlock;
}

export const ErrorContent: React.FC<ErrorContentProps> = ({ content }) => {
  const { t } = useTranslation('pleri/chat');
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.refetchQueries({
      queryKey: ['pleriStatus'],
    });
    queryClient.refetchQueries({
      queryKey: ['pleri-models'],
    });
  }, [queryClient]);

  return (
    <div className="my-3 overflow-hidden rounded-lg border border-red-300 bg-red-50/30 dark:bg-red-950/30">
      <div className="flex items-center gap-2.5 bg-red-50/80 px-4 py-2.5 dark:bg-red-950/80">
        <div className="flex h-6 w-6 items-center justify-center rounded-md bg-red-100 text-red-600 dark:bg-red-900">
          <svg
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
            />
          </svg>
        </div>
        <span className="font-medium text-red-600">
          {content.title || t('error')}
        </span>
      </div>
      <div className="border-t border-red-200/50 p-4 dark:border-red-700/50">
        <div className="prose prose-sm max-w-none text-red-700">
          <ChatMarkdown content={content.error} />
        </div>
      </div>
    </div>
  );
};
